import { defineMessages } from 'react-intl';

export default defineMessages({
  btnOpenTooltip: {
    id: '',
    description: 'Tooltip on open modal button',
    defaultMessage: 'Request attachments',
  },
  btnClose: {
    id: '',
    description: 'Attachments close button',
    defaultMessage: 'Done',
  },
  btnAdd: {
    id: '',
    description: 'Button for adding attachment',
    defaultMessage: 'Add attachment',
  },
  btnUpdate: {
    id: '',
    description: 'Button for updating current attachment',
    defaultMessage: 'Update attachment',
  },
  modalTitle: {
    id: '',
    description: 'Attachments modal title',
    defaultMessage: 'Requested attachments',
  },
  modalSubtext: {
    id: '',
    description: 'Attachments modal subtext below title',
    defaultMessage: 'Which attachments should the signer upload when signing? You may request up to five.',
  },
  fieldNameLabel: {
    id: '',
    description: 'Label for attachments name field',
    defaultMessage: 'Attachment name*',
  },
  fieldNamePlaceholder: {
    id: '',
    description: 'Placeholder for attachments name field when there is no text',
    defaultMessage: 'Name of document',
  },
  fieldInstructionsLabel: {
    id: '',
    description: 'Label for attachments instructions field',
    defaultMessage: 'Instructions',
  },
  fieldInstructionsPlaceholder: {
    id: '',
    description: 'Placeholder for attachments instructions field when there is no text',
    defaultMessage: 'Enter any additional information here',
  },
  fieldRequiredLabel: {
    id: '',
    description: 'Label for attachments required field',
    defaultMessage: 'Required',
  },
  nameNotUniqueError: {
    id: '',
    description: 'Error message for a non-unique attachment name',
    defaultMessage: 'Name must be unique',
  },
  modalUpsellAttachment: {
    id: '',
    description: 'view plans and pricing button/title on the pop up modal when request attachments are disabled',
    defaultMessage: 'View plans and pricing',
  },
  modalBodyUpsell: {
    id: '',
    description: 'body content of the pop up modal on request attachments when attachment are disabled',
    defaultMessage: 'Here you can request the signer to attach files when they sign (such as a copy of their photo ID). This feature is only available with our Enterprise plan.',
  },
});
